import { render, staticRenderFns } from "./CollegeProfile.vue?vue&type=template&id=207c6fe8"
import script from "./CollegeProfile.vue?vue&type=script&lang=js"
export * from "./CollegeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports